import React from "react";

const ViewIcon = ({
  style = {},
  width = "70",
  height = "70",
  className = "",
  fill = "#7758B3",
  stroke = "#7758B3",
  viewBox = "0 0 70 70",
}) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" >
  <path d="M9 4.5C3.891 4.5 0.75 9 0.75 9C0.75 9 3.891 13.5 9 13.5C14.109 13.5 17.25 9 17.25 9C17.25 9 14.109 4.5 9 4.5ZM9 12C6.04275 12 3.8055 10.137 2.715 9C3.495 8.18625 4.86225 7.00725 6.65625 6.3975C6.23409 6.9229 6.00272 7.57601 6 8.25C6 9.9075 7.3425 11.25 9 11.25C10.6575 11.25 12 9.9075 12 8.25C12 7.54725 11.7487 6.90975 11.3438 6.3975C13.1385 7.00725 14.5057 8.187 15.2843 9C14.1923 10.1385 11.9557 12 8.99925 12H9Z" fill="#8A8A8A"/>
  </svg>

     
);

export default ViewIcon;
